 <div class="reminder" *ngIf="fromList">
    <div class="remind">
      <div class="mlabel">Assigned To</div>     
    </div>
    
    <div class="block">
      <mat-radio-group aria-label="Select an option" color="primary" (change)="selectCRE($event)">
        <mat-radio-button value="Contact" [checked]="checkedContact">{{ContactShowName}}</mat-radio-button>
        <mat-radio-button value="Role" [checked]="checkedRole">Role</mat-radio-button>
        <mat-radio-button value="Email" [checked]="checkedEmail">Email</mat-radio-button>
        <mat-radio-button value="User" [checked]="checkedUser">User</mat-radio-button>
      </mat-radio-group>
    </div>

    <div class="block mt-20" *ngIf="ShowContactBox"> 
    <mat-form-field  appearance="" class="mt-10 mb-10" style="position: relative;" >
      <mat-label>Search {{ContactShowName}}</mat-label>
      <input matInput
             maxlength="50"
             placeholder= "Type & Select"
             aria-label="State"
             [matAutocomplete]="auto" 
             (input)="searchContact($event.target.value)"
             [formControl]="stateCtrl"
             id="stateCtrlid"                        
             (keydown.enter)="onEnter($event,'')">
       <mat-autocomplete #auto="matAutocomplete">
        <mat-option (keydown.enter)="onEnter($event,contact)"
        (click)="contactSelected(contact)" *ngFor="let contact of contactsList" [value]="contact.name">
          <span class="userlist" fxLayout="row" fxLayoutAlign="flex-start center">
              <div class="userpic">
                  <img *ngIf="contact.imageUrl!=''" src="{{contact.imageUrl}}" alt="">
                  <span class="username" *ngIf="contact.imageUrl==''" class="username">
                      {{contact.shortName}}
                    </span>
              </div>
              <div class="info">
                <p> {{ contact.name }}</p>
                <p class="email">{{ contact.email }}</p>
              </div> 
          </span>
        </mat-option>
      </mat-autocomplete>
     
    </mat-form-field>
    <ul  class="selectedlist">
      <li *ngFor="let contact of selectedContacts">
        <div class="userndetail">
          <div class="userpic">
            <img *ngIf="contact.img!=''" src="{{contact.img}}" alt="">
            <span *ngIf="contact.img==''" class="username">
              {{contact.shortName}}
            </span>
          </div>
          <div class="detail">
            <h4>{{contact.name}}</h4>
            <p>{{contact.email}}</p>
          </div>      
            <div class="opt">
                <button mat-icon-button><mat-icon (click)="removeContact(contact)">cancel</mat-icon></button>
            </div>
        </div>
      </li>
    </ul>
   </div>

   <div class="block mt-20" *ngIf="ShowRoleBox"> 
    <mat-form-field  appearance="" class="mt-10 mb-10" style="position: relative;" >
      <mat-label>Search role</mat-label>
      <input matInput
             maxlength="50"
             placeholder= "Search role"
             aria-label="State"
             [matAutocomplete]="auto" 
             (input)="searchRoles($event.target.value)"
             [formControl]="stateCtrl"
             id="stateCtrlid">
       <mat-autocomplete #auto="matAutocomplete">
        <mat-option (click)="roleSelected(obj)"        
        *ngFor="let obj of RoleList" [value]="obj.roleName">
       <span class="userlist" fxLayout="row" fxLayoutAlign="flex-start center">         
           <div class="info">
             <p> {{ obj.roleName }}</p>
           </div> 
       </span>
     </mat-option>
      </mat-autocomplete>
    
    </mat-form-field>
    <ul  class="selectedlist">
      <li *ngFor="let role of selectedRole">
        <div class="userndetail">
            <div class="detail">
                <h4> {{role.name}}</h4>
            </div>
            <div class="opt">
                <button mat-icon-button ><mat-icon (click)="removeRole(role)">cancel</mat-icon></button>
            </div>
        </div>
      </li>
    </ul>
   </div>


   <div class="block mt-20" *ngIf="ShowEmailBox">
    <mat-form-field>
      <input matInput maxlength="100" class="form-control mtb-15" placeholder="Add email"
      [(value)]="emailAssigned" (input)="emailCheck($event.target.value)"/>
    </mat-form-field>
      
      <button color="primary" *ngIf="addEmailButtonShow" (click)="addEmail()"
       mat-icon-button style="position: absolute; right: 0; top: -15px;">
        <mat-icon>add</mat-icon>
      </button>
   
    <ul  class="selectedlist">
      <li *ngFor="let email of selectedEmail">
        <div class="userndetail"> 
          <div class="detail">          
            <p>{{email.email}}</p>
          </div>      
            <div class="opt">
                <button mat-icon-button><mat-icon (click)="removeEmail(email)">cancel</mat-icon></button>
            </div>
        </div>
      </li>
    </ul>       
                            
      
    </div>     
         
    
    <div class="block mt-20" *ngIf="ShowUserBox">
      <mat-form-field  appearance="" class="mt-10 mb-10" style="position: relative;" >
        <mat-label>Search user</mat-label>
        <input matInput
               maxlength="50"
               placeholder= "Type & Select"
               aria-label="State"
               [matAutocomplete]="auto" 
               (input)="searchUser($event.target.value)"
               [formControl]="stateCtrl"
               id="stateCtrlid">
         <mat-autocomplete #auto="matAutocomplete">
          <mat-option (click)="userSelected(user)" *ngFor="let user of userList" [value]="user.name">
            <span class="userlist" fxLayout="row" fxLayoutAlign="flex-start center">
                <div class="userpic">
                    <img *ngIf="user.imageUrl!=''" src="{{user.imageUrl}}" alt="">
                    <span class="username" *ngIf="user.imageUrl==''" class="username">
                        {{user.shortName}}
                      </span>
                </div>
                <div class="info">
                  <p> {{ user.name }}</p>
                  <p class="email">{{ user.email }}</p>
                </div> 
            </span>
          </mat-option>
        </mat-autocomplete>
       
      </mat-form-field>
      <ul  class="selectedlist">
        <li *ngFor="let user of selectedUser">
          <div class="userndetail">            
              <div class="detail">
                  <h4>{{user.name}}</h4>
                  <p>{{user.email}}</p>
              </div>
              <div class="opt">
                  <button mat-icon-button><mat-icon (click)="removeUser(user)">cancel</mat-icon></button>
              </div>
          </div>
        </li>
      </ul>
     </div>   
     
     
     <div class="actionBtnHolder">
      <button mat-flat-button class="cancel" (click)="close()">
        Close
      </button>

      <button mat-flat-button class="calltoaction" type="submit" color="primary"
       [disabled]="!showTaskUpdateButton" 
       (click)="updateTaskDetail()">
       Assign
        <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
        </mat-spinner></mat-icon>
      </button>
      
     
    </div>

  </div>